import styled from 'styled-components'

//----- Styling -----//

export const InputCaption = styled.div`
	margin-bottom: 0.25em;
	color: ${(p) => p.theme.color.gray[46]};
`
